import { render, staticRenderFns } from "./IconRate.vue?vue&type=template&id=4bb83553&"
import script from "./IconRate.vue?vue&type=script&lang=js&"
export * from "./IconRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports